import React from 'react'
import TextField from 'material-ui/TextField'
import ScannedTextList from './ScannedTextList'

const CodeField = ({
  code,
  handleFieldChange,
  errorText,
  gotScannedText,
  handleScanned,
  scannedText
}) => {
  return (
    <div>
      <TextField
        style={{textAlign: 'left'}}
        floatingLabelText="Code"
        value={code}
        multiLine={true}
        onChange={handleFieldChange}
        errorText={errorText}
      />
      {gotScannedText && (
        <ScannedTextList
          handleChange={handleScanned}
          scannedText={scannedText}
        />
      )}
    </div>
  )
}

export default CodeField



// WEBPACK FOOTER //
// ./src/components/CodeField.js